import { getNavigator } from "@faire/web/common/globals/getNavigator";

export const isChromeLighthouse = () =>
  !!getNavigator()?.userAgent.toLowerCase().includes("chrome-lighthouse");
